//jshint module : true
import actionTypes from './action-types';

const setPageType = type => {
    return {
        type: actionTypes.SET_PAGE_TYPE,
        payload: type
    };
};

const setPageMeta = meta => {
    return {
        type: actionTypes.SET_PAGE_META,
        payload: meta
    };
};

const setPageMetaFromSearchResult = meta => (dispatch, getState) => {
    const { page } = getState();
    if (page.blockMetaTitleFromSearchResult) {
        delete meta.metaTitle;
    }
    dispatch({
        type: actionTypes.SET_PAGE_META_FROM_SEARCH_RESULT,
        payload: meta
    });
};

export default {
    setPageType,
    setPageMeta,
    setPageMetaFromSearchResult
};
